import PageTitle from "components/PageTitle";
import React, { useEffect, useState } from "react";
import { Button, Card, Toast } from "react-bootstrap";
import { ProgramaCreateModal } from "./components/ProgramaCreateModal";
import axios from "axios";
import { IAlvo } from "./Alvo";
import Table from "components/TableComp";
import { ConfirmAlert } from "components";
import ProgramaDetalheModal from "./components/ProgramaDetalheModal";
import ProgramaEditModal from "./components/ProgramaEditModal";
import { IPersonalizacao } from "./components/Personalizacoes";
import { Badge } from "antd";

export interface IPrograma {
  id?: number;
  titulo: string;
  campos_personalizados: IPersonalizacao[];
  categoria_id: number;
  categoria: {
    id: number;
    cor: string;
    nome: string;
  };
  alvos: IAlvo[];
  escolhas: {
    id: number;
    programa_id: number;
    resposta: string;
    opcao_campoprograma_id: number;
    campo: {
      id: number;
      nome: string;
      obrigatorio: boolean;
      tipocampo_id: number;
      ordem: number;
    };
  }[];
}
interface IColunaAction {
  row: IPrograma;
  deleteFn: (id: number) => void;
  editFn: () => void;
}
export function ColunaAction({ row, deleteFn, editFn }: IColunaAction) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "end",
        gap: "8px",
      }}
    >
      <span
        className="action-icon"
        style={{ cursor: "pointer" }}
        onClick={(e) => {
          e.stopPropagation();
          editFn();
        }}
        title="Editar"
      >
        <i className="mdi mdi-square-edit-outline" />
      </span>

      <ConfirmAlert
        text={`Excluir o item "${row.titulo}"?`}
        cb={() => deleteFn?.(row.id!)}
      >
        <span
          style={{
            cursor: "pointer",
            margin: "2px",
          }}
          title="Excluir"
        >
          <i className="mdi mdi-delete" />
        </span>
      </ConfirmAlert>
    </div>
  );
}
export default function ProgramaListagem() {
  const [modalCreate, setModalCreate] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("");
  const [programas, setProgramas] = useState<IPrograma[]>([]);
  const [detalheModal, setDetalheModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [programa, setPrograma] = useState<IPrograma>({
    titulo: "",
    categoria: { id: -1, nome: "", cor: "" },
    categoria_id: -1,
    alvos: [],
    escolhas: [],
    campos_personalizados: [],
  });

  useEffect(() => {
    const fetchProgramas = async () => {
      const prog = (await axios.get("/programa")).data;
      setProgramas(prog);
    };
    fetchProgramas();
  }, []);

  return (
    <>
      <PageTitle
        breadCrumbItems={[
          { label: "Currículo", path: "#" },
          {
            label: "Listagem de Programas",
            path: "/curriculo/programa",
            active: true,
          },
        ]}
        title="Listagem de Programas"
      />
      <div
        style={{
          position: "fixed",
          top: 20,
          right: 20,
          zIndex: 999999,
        }}
      >
        <Toast
          show={showToast}
          onClose={() => setShowToast(false)}
          delay={2000}
          autohide
          bg={toastType === "success" ? "success" : "danger"}
        >
          <Toast.Body className="text-white">{toastMessage}</Toast.Body>
        </Toast>
      </div>
      <Card>
        <Card.Body>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h4 className="header-title mb-0">Programas</h4>
            <Button
              variant="primary"
              onClick={() => {
                setModalCreate(true);
              }}
            >
              <i className="mdi mdi-plus-circle me-1" />
              Novo Programa
            </Button>
          </div>
          <Table
            columns={[
              {
                Header: "Programa",
                accessor: "titulo",
                sort: false,
                Cell: (row) => {
                  return (
                    <>
                      <i
                        onClick={() => {
                          setPrograma(row.row.original);
                          setDetalheModal(true);
                        }}
                        style={{ cursor: "pointer" }}
                        className="mdi mdi-book-open-variant"
                      />
                      <span style={{ margin: "7px" }}>
                        {row.row.original.titulo}
                      </span>
                    </>
                  );
                },
              },
              {
                Header: "Categoria",
                accessor: " ",
                sort: false,
                Cell: (row) => {
                  return (
                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                      }}
                    >
                      <Badge
                      color={row.row.original.categoria.cor}
                      text={row.row.original.categoria.nome}
                      ></Badge>
                      {/* {row.row.original.categoria.nome}
                      <div
                        style={{
                          minWidth: "7%",
                          borderRadius: "15%",
                          backgroundColor: `${
                            row.row.original.categoria.cor
                              ? row.row.original.categoria.cor
                              : ""
                          }`,
                        }}
                      /> */}
                    </div>
                  );
                },
              },
              {
                Header: "",
                accessor: "id",
                Cell: (row) => {
                  return (
                    <ColunaAction
                      row={row.row.original}
                      deleteFn={async () => {
                        await axios.delete(`/programa/${row.row.original.id}`);
                        setProgramas(
                          programas.filter((p) => p.id != row.row.original.id),
                        );
                      }}
                      editFn={() => {
                        setEditModal(true);
                        setPrograma(row.row.original);
                      }}
                    />
                  );
                },
              },
            ]}
            data={programas}
          ></Table>
        </Card.Body>
      </Card>
      <ProgramaCreateModal
        show={modalCreate}
        onSave={(success, programa?: IPrograma) => {
          success ? setToastType("success") : setToastType("");
          success
            ? setToastMessage("Programa criado com sucesso!")
            : setToastMessage("Erro ao criar programa");
          if (programa) setProgramas(programas.concat(programa));
          setShowToast(true);
        }}
        onHide={() => {
          setModalCreate(false);
        }}
      />
      <ProgramaDetalheModal
        show={detalheModal}
        onHide={() => {
          setDetalheModal(false);
        }}
        programa={programa}
      />
      <ProgramaEditModal
        show={editModal}
        onHide={() => {
          setEditModal(false);
        }}
        onSave={(success, programa?: IPrograma) => {
          success ? setToastType("success") : setToastType("");
          success
            ? setToastMessage("Programa criado com sucesso!")
            : setToastMessage("Erro ao criar programa");
          if (programa) {
            setProgramas(
              programas.filter((p) => p.id !== programa.id).concat(programa),
            );
          }
          setShowToast(true);
        }}
        programa={programa}
      />
    </>
  );
}
